import { useQuery } from "@tanstack/react-query";
import { QueryTypes } from "./shared";
import { queryClient } from "src";
import  EnterpriseApiService  from "src/api/EnterpriseApiService";
import BinInfoDTO from "src/models/BinInfoDTO";
import { queryOptions } from "./v4QueryOptions/queryOptions";

export const getBinsQueryOptions = (desiredGrowerId?: number | null) => {
    return queryOptions({
        queryKey: ["getBinsQuery", desiredGrowerId] as const,
        queryFn: async (q) => {
                if(desiredGrowerId == null){
                    return await EnterpriseApiService.getBinIDs();
                }else{
                    return await EnterpriseApiService.getBinIDsByGrower(desiredGrowerId);
                }
            },
            initialData: () => {
                const data = queryClient.getQueryData<BinInfoDTO[] | undefined>([ "getBinsQuery", desiredGrowerId]);
                if(data != null){
                    return data as BinInfoDTO[];
                }
                return [];
            },
    })
};
